(function () {
    'use strict';
    
    angular
        .module('plagiat2017App')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];
    
    function stateConfig($stateProvider) {
        $stateProvider
            .state('tags-list', {
                parent: 'account',
                url: '/tags-list',
                data: {
                    authorities: ['PERM_USER_ADMIN'],
                    pageTitle: 'tags.edit.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/tags/tags-list.template.html',
                        controller: 'TagsListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translatePartialLoader.addPart('tags');
                        return $translate.refresh();
                    }]
                }
            })
            .state("tag-group-add", {
                parent: "tags-list",
                url: "/add-edit/:id",
                data: {
                    authorities: ['PERM_USER_ADMIN'],
                    pageTitle: 'tags.edit.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/tags/tag-group-add.template.html',
                        controller: 'TagGroupAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translatePartialLoader.addPart('tags');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }
})();
